import React, { useEffect, useState } from 'react';

const ProfileInfo = () => {
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const token = localStorage.getItem("token");

                const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/pofileinfo/`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                const data = await res.json();

                if (data.status) {
                    setProfile(data.data);
                } else {
                    console.error(data.error);
                }
            } catch (err) {
                console.error("Profile fetch error:", err);
            }
        };

        fetchProfile();
    }, []);

    if (!profile) return <p className="text-center py-40">Loading...</p>;

    return (
        <section className="contact py-80">
            <div className="container container-lg">
                <div className="row gy-5">

                    {/* LEFT SIDE - PROFILE DETAILS */}
                    <div className="col-lg-8">
                        <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                            <h6 className="mb-32">My Profile</h6>

                            <div className="row gy-4">

                                <div className="col-sm-6">
                                    <label className="text-sm fw-semibold mb-4">First Name</label>
                                    <input
                                        type="text"
                                        className="common-input px-16"
                                        value={profile.first_name}
                                        readOnly
                                    />
                                </div>

                                <div className="col-sm-6">
                                    <label className="text-sm fw-semibold mb-4">Last Name</label>
                                    <input
                                        type="text"
                                        className="common-input px-16"
                                        value={profile.last_name}
                                        readOnly
                                    />
                                </div>

                                <div className="col-sm-6">
                                    <label className="text-sm fw-semibold mb-4">Email</label>
                                    <input
                                        type="email"
                                        className="common-input px-16"
                                        value={profile.email}
                                        readOnly
                                    />
                                </div>

                                <div className="col-sm-6">
                                    <label className="text-sm fw-semibold mb-4">Phone</label>
                                    <input
                                        type="text"
                                        className="common-input px-16"
                                        value={profile.phone}
                                        readOnly
                                    />
                                </div>

                                <div className="col-sm-12">
                                    <label className="text-sm fw-semibold mb-4">Address</label>
                                    <input
                                        type="text"
                                        className="common-input px-16"
                                        value={profile.address}
                                        readOnly
                                    />
                                </div>

                                <div className="col-sm-4">
                                    <label className="text-sm fw-semibold mb-4">City</label>
                                    <input
                                        type="text"
                                        className="common-input px-16"
                                        value={profile.city}
                                        readOnly
                                    />
                                </div>

                                <div className="col-sm-4">
                                    <label className="text-sm fw-semibold mb-4">State</label>
                                    <input
                                        type="text"
                                        className="common-input px-16"
                                        value={profile.state}
                                        readOnly
                                    />
                                </div>

                                <div className="col-sm-4">
                                    <label className="text-sm fw-semibold mb-4">Pincode</label>
                                    <input
                                        type="text"
                                        className="common-input px-16"
                                        value={profile.pincode}
                                        readOnly
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE - PROFILE SUMMARY */}
                    <div className="col-lg-4">
                        <div className="contact-box border border-gray-100 rounded-16 px-24 py-40 text-center">

                            <img
                                src={profile.avatar}
                                alt="avatar"
                                className="rounded-circle mb-16"
                                width="100"
                                height="100"
                            />

                            <h6 className="mb-8">
                                {profile.first_name} {profile.last_name}
                            </h6>

                            <p className="text-gray-600 mb-16">@{profile.username}</p>

                            <div className="text-md text-gray-900 mb-8">
                                📧 {profile.email}
                            </div>

                            <div className="text-md text-gray-900 mb-8">
                                📞 {profile.phone}
                            </div>

                            <div className="text-md text-gray-900">
                                📍 {profile.city}, {profile.state}
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ProfileInfo;